/**
 * Пак «Бирияни» — фоны и шаги `state_desktop_*` / `state_mobile_*` в `packs/biryani/`.
 */
import biryaniBgDesktop from '@/assets/img/rice-game/packs/biryani/bg-desktop.jpg';
import biryaniBgDesktop2x from '@/assets/img/rice-game/packs/biryani/bg-desktop@2x.jpg';
import biryaniBgMobile from '@/assets/img/rice-game/packs/biryani/bg-mobile.jpg';
import biryaniBgMobile2x from '@/assets/img/rice-game/packs/biryani/bg-mobile@2x.jpg';

import biryaniStateD01 from '@/assets/img/rice-game/packs/biryani/state_desktop_1.png';
import biryaniStateD02 from '@/assets/img/rice-game/packs/biryani/state_desktop_2.png';
import biryaniStateD03 from '@/assets/img/rice-game/packs/biryani/state_desktop_3.png';
import biryaniStateD04 from '@/assets/img/rice-game/packs/biryani/state_desktop_4.png';
import biryaniStateD05 from '@/assets/img/rice-game/packs/biryani/state_desktop_5.png';
import biryaniStateD06 from '@/assets/img/rice-game/packs/biryani/state_desktop_6.png';
import biryaniStateD07 from '@/assets/img/rice-game/packs/biryani/state_desktop_7.png';
import biryaniStateD08 from '@/assets/img/rice-game/packs/biryani/state_desktop_8.png';
import biryaniStateD09 from '@/assets/img/rice-game/packs/biryani/state_desktop_9.png';
import biryaniStateD10 from '@/assets/img/rice-game/packs/biryani/state_desktop_10.png';
import biryaniStateD11 from '@/assets/img/rice-game/packs/biryani/state_desktop_11.png';
import biryaniStateD12 from '@/assets/img/rice-game/packs/biryani/state_desktop_12.png';
import biryaniStateD13 from '@/assets/img/rice-game/packs/biryani/state_desktop_13.png';
import biryaniStateD14 from '@/assets/img/rice-game/packs/biryani/state_desktop_14.png';
import biryaniStateD15 from '@/assets/img/rice-game/packs/biryani/state_desktop_15.png';
import biryaniStateD16 from '@/assets/img/rice-game/packs/biryani/state_desktop_16.png';

import biryaniStateM01 from '@/assets/img/rice-game/packs/biryani/state_mobile_1.png';
import biryaniStateM02 from '@/assets/img/rice-game/packs/biryani/state_mobile_2.png';
import biryaniStateM03 from '@/assets/img/rice-game/packs/biryani/state_mobile_3.png';
import biryaniStateM04 from '@/assets/img/rice-game/packs/biryani/state_mobile_4.png';
import biryaniStateM05 from '@/assets/img/rice-game/packs/biryani/state_mobile_5.png';
import biryaniStateM06 from '@/assets/img/rice-game/packs/biryani/state_mobile_6.png';
import biryaniStateM07 from '@/assets/img/rice-game/packs/biryani/state_mobile_7.png';
import biryaniStateM08 from '@/assets/img/rice-game/packs/biryani/state_mobile_8.png';
import biryaniStateM09 from '@/assets/img/rice-game/packs/biryani/state_mobile_9.png';
import biryaniStateM10 from '@/assets/img/rice-game/packs/biryani/state_mobile_10.png';
import biryaniStateM11 from '@/assets/img/rice-game/packs/biryani/state_mobile_11.png';
import biryaniStateM12 from '@/assets/img/rice-game/packs/biryani/state_mobile_12.png';
import biryaniStateM13 from '@/assets/img/rice-game/packs/biryani/state_mobile_13.png';
import biryaniStateM14 from '@/assets/img/rice-game/packs/biryani/state_mobile_14.png';
import biryaniStateM15 from '@/assets/img/rice-game/packs/biryani/state_mobile_15.png';
import biryaniStateM16 from '@/assets/img/rice-game/packs/biryani/state_mobile_16.png';

export const biryaniBackgrounds = {
  backgroundDesktop: biryaniBgDesktop,
  backgroundDesktop2x: biryaniBgDesktop2x,
  backgroundMobile: biryaniBgMobile,
  backgroundMobile2x: biryaniBgMobile2x,
};

export const biryaniFramesDesktop = [
  biryaniStateD01,
  biryaniStateD02,
  biryaniStateD03,
  biryaniStateD04,
  biryaniStateD05,
  biryaniStateD06,
  biryaniStateD07,
  biryaniStateD08,
  biryaniStateD09,
  biryaniStateD10,
  biryaniStateD11,
  biryaniStateD12,
  biryaniStateD13,
  biryaniStateD14,
  biryaniStateD15,
  biryaniStateD16,
];

export const biryaniFramesMobile = [
  biryaniStateM01,
  biryaniStateM02,
  biryaniStateM03,
  biryaniStateM04,
  biryaniStateM05,
  biryaniStateM06,
  biryaniStateM07,
  biryaniStateM08,
  biryaniStateM09,
  biryaniStateM10,
  biryaniStateM11,
  biryaniStateM12,
  biryaniStateM13,
  biryaniStateM14,
  biryaniStateM15,
  biryaniStateM16,
];
